import { EncuestaDTO, PreguntaDTO } from "@DTOS";

export abstract class CuestionariosUtils {
    abstract obtenerPreguntasParseadas(encuesta: EncuestaDTO): PreguntaDTO[];
    abstract enviarPruebaInternaAsync(): Promise<any>;
}
